module.exports = __webpack_public_path__ + "static/media/2.9e0c43ef.svg";